import script from "./MCP.vue?vue&type=script&setup=true&lang=js"
export * from "./MCP.vue?vue&type=script&setup=true&lang=js"

import "./MCP.vue?vue&type=style&index=0&id=1db7cd9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db7cd9e"]])

export default __exports__